import React from 'react';

import { Card, TableWithCheckboxAndDelete, CheckBox, Pagination } from '../components/library-components';
import { Trash } from '@quintype/em/icons/trash';

export default class OrganizationSubscriptionMembers extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      allSelected: false
    };
  }

  toggleAllSelected () {
    this.setState({ allSelected: !this.state.allSelected });
    this.props.toggleAllMemberSelection(!this.state.allSelected);
  }

  deleteAllMembers () {
    this.props.deleteMembers();
    this.setState({ allSelected: false });
  }

  render () {
    return (
      <Card title='Members'>
        <TableWithCheckboxAndDelete
          header={['Name', 'Email']}
          onCheckboxClick={() => this.toggleAllSelected()}
          showDeleteButton={this.state.allSelected || this.props.someMembersSelected}
          onDeleteMembers={() => this.deleteAllMembers()}
          checked={this.state.allSelected}
          checkboxDataTest='all-members-checkbox'
          deleteDataTest='all-members-delete'
        >
          {this.props.members.map((member, i) => (
            <div className='table-default__row' key={i} data-test-id={`member-${i}`}>
              <div className='table-default__cell table-default__checkbox'>
                <CheckBox
                  checked={member.checked}
                  onChange={() => this.props.toggleMemberSelection(member, i)}
                  dataTest='member-checkbox'
                />
              </div>
              <div className='table-default__cell truncate-word' data-test-id='member-name'>{member.name}</div>
              <div className='table-default__cell truncate-word' data-test-id='member-email'>{member.email}</div>
              {<div onClick={() => this.props.deleteMembers(member.id)} style={{ cursor: 'pointer', visibility: member.checked ? 'visible' : 'hidden' }} data-test-id='delete-member'><Trash /></div>}
            </div>
          ))}
        </TableWithCheckboxAndDelete>
        <Pagination
          onPageChange={page => this.props.onPageChange(page)}
          pageCount={this.props.pageCount}
          containerClassName='pagination'
          pageRangeDisplayed={0}
          marginPagesDisplayed={1}
          pageClassName='pagination__item'
          breakClassName='pagination__item'
          breakLabel='...'
          totalEnteries={`${this.props.totalEntries} rows`}
        />
      </Card>
    );
  }
}
